import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_OWNER_DASHBOARD_STAT } from "./apiRoutes";

interface UseGetOwnerDashboardParkedStatusProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnerDashboardParkedStatus = async (
  communityId: string,
  year: string
) =>
  await axiosAuth.get(
    `${BOM_OWNER_DASHBOARD_STAT(communityId)}/parked-status?budgetYear=${year}`
  );

const useGetOwnerDashboardParkedStatus = ({
  communityId,
  year,
  queryParams,
}: UseGetOwnerDashboardParkedStatusProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bom-owner-dashboard-parked-status", communityId, year],
    queryFn: () => getOwnerDashboardParkedStatus(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetOwnerDashboardParkedStatus;
